import React, { useState } from "react";
import { 
  Card, CardHeader, CardContent, Typography, Box
} from "@mui/material";
import CustomInput from "../../components/FormFields/CustomInput";
import { useQuery } from "react-query";
import { QK } from "../../base/qk";
import { getLocations, getSubLocations } from "../../api/services/scheduling";
import CustomSelect from "../../components/FormFields/CustomSelect/CustomSelect";
import { statusOptions } from "../../components/Clients/client.config";
import { ImageUpload } from "../../components/CustomForm";

const GeneralInfo = ({ handleChange, data, setFormData, errors }) => {
  const [selectedLocationId, setSelectedLocationId] = useState(null);

  const { data: locations } = useQuery([QK.location], () => getLocations());
  const { data: sublocations } = useQuery(
    [QK.subLocations, selectedLocationId || data?.location],
    () => getSubLocations(selectedLocationId || data?.location),
    { enabled: !!(selectedLocationId || data?.location) }
  );

  const locationOptions = locations?.map((loc) => ({
    value: loc.id,
    label: loc.name,
  })) || [];

  const areaOptions = sublocations?.map((sub) => ({
    value: sub.id,
    label: sub.name,
  })) || [];

  const statusOptionsFormatted = statusOptions?.map((opt) => ({
    value: opt.value || opt,
    label: opt.label || opt,
  })) || [];

  const handleFileUpload = (event) => {
    const { fileData } = event.target;
    if (fileData?.url) {
      if (setFormData) {
        setFormData("profile_photo", fileData.url);
      }
    }
  };

  const handleChangeLocal = (event) => {
    const { name, value } = event.target || {};
    if (handleChange) {
      handleChange(event);
    }
  };

  const handleLocationChange = (event) => {
    const { value } = event.target;
    setSelectedLocationId(value);
    if (handleChange) {
      handleChange(event);
    }
  };

  const imageUrl = data?.profile_photo || "";

  return (
    <Box sx={{ width: '100%', mb: 1 }}>
      <Card variant="outlined" sx={{ borderRadius: 2, border: '1px solid #E4E7EC' }}>
        <CardHeader
          title={
            <Typography variant="subtitle1" sx={{ fontWeight: 700, color: '#1570EF' }}>
              General Info
            </Typography>
          }
          sx={{ 
            backgroundColor: '#F9FAFB', 
            py: 0.75, 
            px: 2, 
            borderBottom: '1px solid #EAECF0' 
          }}
        />
        
        <CardContent sx={{ p: 2.5 }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 4 }}>
            <Box sx={{ position: 'relative', flexShrink: 0 }}>
              <ImageUpload
                name="profile_photo"
                label=""
                onChange={handleFileUpload}
                value={data?.profile_photo || ""}
                accept="image/jpeg,image/png"
                maxSize={5 * 1024 * 1024}
                folder="profile_photos"
                circular={true}
                preview={true}
                required={false}
              />
            </Box>

            <Box sx={{ flex: 1, display: 'flex', flexWrap: 'wrap', gap: 2 }}>
              <Box sx={{ flex: '1 1 200px', minWidth: '160px' }}>
                <CustomInput 
                  label="NHS Number" 
                  name="nhs_number" 
                  value={data?.nhs_number ?? ""} 
                  onChange={handleChangeLocal} 
                  fullWidth 
                  size="small"
                  placeholder="e.g., 123 456 7890"
                  error={!!errors?.nhs_number}
                  helperText={errors?.nhs_number || ""}
                />
              </Box>
              <Box sx={{ flex: '1 1 160px', minWidth: '130px' }}>
                <CustomSelect
                  options={statusOptionsFormatted}
                  value={data?.status ?? "Active"}
                  onChange={handleChangeLocal}
                  placeholder="Status"
                  fullWidth
                  size="small"
                  name="status"
                  error={!!errors?.status}
                  helperText={errors?.status || ""}
                />
              </Box>
              <Box sx={{ flex: '1 1 190px', minWidth: '150px' }}>
                <CustomSelect
                  options={locationOptions}
                  value={selectedLocationId || data?.location || ""}
                  onChange={handleLocationChange}
                  placeholder="Zone"
                  fullWidth
                  size="small"
                  name="location"
                  error={!!errors?.location}
                  helperText={errors?.location || ""}
                />
              </Box>
              <Box sx={{ flex: '1 1 190px', minWidth: '150px' }}>
                <CustomSelect
                  options={areaOptions}
                  value={data?.area || ""}
                  onChange={handleChangeLocal}
                  placeholder="Area"
                  fullWidth
                  size="small"
                  name="area"
                  error={!!errors?.area}
                  helperText={errors?.area || ""}
                />
              </Box>
            </Box>
          </Box>
        </CardContent>
      </Card>
    </Box>
  );
};

export default GeneralInfo;